<template>
  <el-dialog
    title="撤回原因"
    :visible.sync="dialogVisible"
    top="300px"
    width="400px"
    @close="handleCancel"
  >
    <el-form ref="dialogForm" :model="dialogForm" :rules="rules">
      <el-form-item prop="revocationCause">
        <el-input v-model="dialogForm.revocationCause" rows="4" type="textarea" placeholder="请输入撤回原因" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="dialogLoading" type="primary" @click="doRevocation">
        撤回
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { orderTakerRevocation } from '@/API/international';
import { Notification } from 'element-ui';

export default {
  name: 'InternationalRevocationDialog',
  props: {
    dialogVisibleFormRevocation: {
      type: Boolean,
      default: false
    },
    currentClickData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dialogForm: {
        revocationCause: ''
      },
      rules: {
        revocationCause: [
          { required: true, message: '请输入撤销原因', trigger: 'blur' }
        ]
      },
      dialogVisible: this.dialogVisibleFormRevocation,
      dialogLoading: false
    };
  },
  watch: {
    dialogVisibleFormRevocation (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-status-dialog', val);
    }
  },
  methods: {
    /**
     * @param type
     * -1 废弃 0 驳回 1 召回 2 同意 3 撤回（订单员）
     */
    doRevocation (type) {
      this.$refs.dialogForm.validate(isPass => {
        if (isPass) {
          this.dialogLoading = true;
          let params = {
            partialDeliveryNum: this.currentClickData.deliveryNum, // 申请发货单号
            approvalComments: this.dialogForm.revocationCause,
            approveType: -1,
            id: this.currentClickData.id
          };
          orderTakerRevocation(params).then((res) => {
            let json = res.data;
            if (json.status === '200' && json.data) {
              Notification.success('撤回成功');
              this.$emit('table-refresh');
              this.dialogVisible = false;
            }
            this.dialogLoading = false;
          }).catch(() => {
            this.dialogLoading = false;
          });
        }
      });
    },
    handleCancel () {
      this.$refs.dialogForm.resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped>
/deep/ .el-dialog__body{
  padding-bottom: 0;
}
</style>
